import { h } from "hyperapp";

function vnode(name) {
  return function (attributes, children) {
    return typeof attributes === "object" && !Array.isArray(attributes) ? h(name, attributes, children) : h(name, {}, attributes);
  };
}

export function a(attributes, children) {
  return vnode("a")(attributes, children);
}
export function abbr(attributes, children) {
  return vnode("abbr")(attributes, children);
}
export function address(attributes, children) {
  return vnode("address")(attributes, children);
}
export function area(attributes, children) {
  return vnode("area")(attributes, children);
}
export function article(attributes, children) {
  return vnode("article")(attributes, children);
}
export function aside(attributes, children) {
  return vnode("aside")(attributes, children);
}
export function audio(attributes, children) {
  return vnode("audio")(attributes, children);
}
export function b(attributes, children) {
  return vnode("b")(attributes, children);
}
export function bdi(attributes, children) {
  return vnode("bdi")(attributes, children);
}
export function bdo(attributes, children) {
  return vnode("bdo")(attributes, children);
}
export function blockquote(attributes, children) {
  return vnode("blockquote")(attributes, children);
}
export function br(attributes, children) {
  return vnode("br")(attributes, children);
}
export function button(attributes, children) {
  return vnode("button")(attributes, children);
}
export function canvas(attributes, children) {
  return vnode("canvas")(attributes, children);
}
export function caption(attributes, children) {
  return vnode("caption")(attributes, children);
}
export function cite(attributes, children) {
  return vnode("cite")(attributes, children);
}
export function code(attributes, children) {
  return vnode("code")(attributes, children);
}
export function col(attributes, children) {
  return vnode("col")(attributes, children);
}
export function colgroup(attributes, children) {
  return vnode("colgroup")(attributes, children);
}
export function data(attributes, children) {
  return vnode("data")(attributes, children);
}
export function datalist(attributes, children) {
  return vnode("datalist")(attributes, children);
}
export function dd(attributes, children) {
  return vnode("dd")(attributes, children);
}
export function del(attributes, children) {
  return vnode("del")(attributes, children);
}
export function details(attributes, children) {
  return vnode("details")(attributes, children);
}
export function dfn(attributes, children) {
  return vnode("dfn")(attributes, children);
}
export function dialog(attributes, children) {
  return vnode("dialog")(attributes, children);
}
export function div(attributes, children) {
  return vnode("div")(attributes, children);
}
export function dl(attributes, children) {
  return vnode("dl")(attributes, children);
}
export function dt(attributes, children) {
  return vnode("dt")(attributes, children);
}
export function em(attributes, children) {
  return vnode("em")(attributes, children);
}
export function embed(attributes, children) {
  return vnode("embed")(attributes, children);
}
export function fieldset(attributes, children) {
  return vnode("fieldset")(attributes, children);
}
export function figcaption(attributes, children) {
  return vnode("figcaption")(attributes, children);
}
export function figure(attributes, children) {
  return vnode("figure")(attributes, children);
}
export function footer(attributes, children) {
  return vnode("footer")(attributes, children);
}
export function form(attributes, children) {
  return vnode("form")(attributes, children);
}
export function h1(attributes, children) {
  return vnode("h1")(attributes, children);
}
export function h2(attributes, children) {
  return vnode("h2")(attributes, children);
}
export function h3(attributes, children) {
  return vnode("h3")(attributes, children);
}
export function h4(attributes, children) {
  return vnode("h4")(attributes, children);
}
export function h5(attributes, children) {
  return vnode("h5")(attributes, children);
}
export function h6(attributes, children) {
  return vnode("h6")(attributes, children);
}
export function header(attributes, children) {
  return vnode("header")(attributes, children);
}
export function hr(attributes, children) {
  return vnode("hr")(attributes, children);
}
export function i(attributes, children) {
  return vnode("i")(attributes, children);
}
export function iframe(attributes, children) {
  return vnode("iframe")(attributes, children);
}
export function img(attributes, children) {
  return vnode("img")(attributes, children);
}
export function input(attributes, children) {
  return vnode("input")(attributes, children);
}
export function ins(attributes, children) {
  return vnode("ins")(attributes, children);
}
export function kbd(attributes, children) {
  return vnode("kbd")(attributes, children);
}
export function label(attributes, children) {
  return vnode("label")(attributes, children);
}
export function legend(attributes, children) {
  return vnode("legend")(attributes, children);
}
export function li(attributes, children) {
  return vnode("li")(attributes, children);
}
export function main(attributes, children) {
  return vnode("main")(attributes, children);
}
export function map(attributes, children) {
  return vnode("map")(attributes, children);
}
export function mark(attributes, children) {
  return vnode("mark")(attributes, children);
}
export function menu(attributes, children) {
  return vnode("menu")(attributes, children);
}
export function menuitem(attributes, children) {
  return vnode("menuitem")(attributes, children);
}
export function meter(attributes, children) {
  return vnode("meter")(attributes, children);
}
export function nav(attributes, children) {
  return vnode("nav")(attributes, children);
}
export function object(attributes, children) {
  return vnode("object")(attributes, children);
}
export function ol(attributes, children) {
  return vnode("ol")(attributes, children);
}
export function optgroup(attributes, children) {
  return vnode("optgroup")(attributes, children);
}
export function option(attributes, children) {
  return vnode("option")(attributes, children);
}
export function output(attributes, children) {
  return vnode("output")(attributes, children);
}
export function p(attributes, children) {
  return vnode("p")(attributes, children);
}
export function param(attributes, children) {
  return vnode("param")(attributes, children);
}
export function pre(attributes, children) {
  return vnode("pre")(attributes, children);
}
export function progress(attributes, children) {
  return vnode("progress")(attributes, children);
}
export function q(attributes, children) {
  return vnode("q")(attributes, children);
}
export function rp(attributes, children) {
  return vnode("rp")(attributes, children);
}
export function rt(attributes, children) {
  return vnode("rt")(attributes, children);
}
export function rtc(attributes, children) {
  return vnode("rtc")(attributes, children);
}
export function ruby(attributes, children) {
  return vnode("ruby")(attributes, children);
}
export function s(attributes, children) {
  return vnode("s")(attributes, children);
}
export function samp(attributes, children) {
  return vnode("samp")(attributes, children);
}
export function section(attributes, children) {
  return vnode("section")(attributes, children);
}
export function select(attributes, children) {
  return vnode("select")(attributes, children);
}
export function small(attributes, children) {
  return vnode("small")(attributes, children);
}
export function source(attributes, children) {
  return vnode("source")(attributes, children);
}
export function span(attributes, children) {
  return vnode("span")(attributes, children);
}
export function strong(attributes, children) {
  return vnode("strong")(attributes, children);
}
export function sub(attributes, children) {
  return vnode("sub")(attributes, children);
}
export function summary(attributes, children) {
  return vnode("summary")(attributes, children);
}
export function sup(attributes, children) {
  return vnode("sup")(attributes, children);
}
export function svg(attributes, children) {
  return vnode("svg")(attributes, children);
}
export function table(attributes, children) {
  return vnode("table")(attributes, children);
}
export function tbody(attributes, children) {
  return vnode("tbody")(attributes, children);
}
export function td(attributes, children) {
  return vnode("td")(attributes, children);
}
export function textarea(attributes, children) {
  return vnode("textarea")(attributes, children);
}
export function tfoot(attributes, children) {
  return vnode("tfoot")(attributes, children);
}
export function th(attributes, children) {
  return vnode("th")(attributes, children);
}
export function thead(attributes, children) {
  return vnode("thead")(attributes, children);
}
export function time(attributes, children) {
  return vnode("time")(attributes, children);
}
export function tr(attributes, children) {
  return vnode("tr")(attributes, children);
}
export function track(attributes, children) {
  return vnode("track")(attributes, children);
}
export function u(attributes, children) {
  return vnode("u")(attributes, children);
}
export function ul(attributes, children) {
  return vnode("ul")(attributes, children);
}
export function video(attributes, children) {
  return vnode("video")(attributes, children);
}
export function wbr(attributes, children) {
  return vnode("wbr")(attributes, children);
}